/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRegistrationV1ProfileState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_REGISTRATION_V1_PROFILE_STATE_ENTITY_NAME = 'ixc.registration.v1.Profile';
export const ixcRegistrationV1ProfileStateEntity = new schema.Entity<IxcRegistrationV1ProfileState>(IXC_REGISTRATION_V1_PROFILE_STATE_ENTITY_NAME, {}, { idAttribute: 'profileId' });

